export const environment = {
  production: true,
  buildId: '2984200891019871',
  configFile: 'config.json',
};
